export default {
  methods: {
    _rcUser() {
      return this.$store?.getters?.userProfile || this.user || {}
    },
    _rcRoles() {
      const roles = this._rcUser()?.roles
      return Array.isArray(roles) ? roles : []
    },
    roleContains(roleList) {
      const wanted = (Array.isArray(roleList) ? roleList : [roleList]).filter(Boolean)
      const roles = this._rcRoles()
      return roles.some(r => wanted.includes(r))
    }
  }
}
